<template>
    <div class="card">
        <div class="card-header">
            Official Phone numbers & Address
        </div>
        <div class="card-body">
            <form class="form-horizontal form-materia" @submit.prevent="submit">
                <div class="form-group">
                    <label class="col-md-12">Add Phone numbers</label>
                    <div class="col-md-12">
                        <input type="tel" v-model="form.phone" class="form-control form-control-line">
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-12">Add office Address</label>
                    <textarea v-model="form.address" rows="5" type="text" class="form-control r-0 s-12" id="address"
                    ></textarea>
                </div>
                <div class="form-group">
                    <div class="col-sm-12">
                        <span class="btn btn-success" v-if="processing">...</span>
                        <button v-else class="btn btn-success"><i class="icon-save mr-2"></i>Update</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
import toastr from 'toastr'
export default {
    name:'exchange-setting',
    props:{
        systemSettings:{
            type:Object,
            required:true
        }
    },
    data(){
        return{
            form:{
                phone_numbers:this.systemSettings.phone_numbers,
                address:this.systemSettings.address
            },
            errors:{
                phone_numbers:null,
                address:null
            }
        }
    },

    computed:{
        ...mapState({
            processing:state=>state.processing
        }),
    },

    methods:{
        ...mapActions('adminStore',['updateSettings']),
        submit(){
            this.updateSettings(this.form).catch(err=>{
                if (err.response && err.response.status === 422) {
                    this.errors = err.response.data.errors;
                    toastr.warning("Ivalid input")
                    console.log("error-" + JSON.stringify(err.response.data));
                }else{
                     toastr.error("An error occured while updating contact details")
                }
                this.$store.commit('processed',null,{root:true})
            })
        }
    },
}
</script>